import { dailyPicks } from "@/mocks/chigua";

export default function DailyPicks() {
  return (
    <section id="picks" className="border-y border-background-200 bg-background-100/70">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs font-medium text-primary-600">
              <i className="ri-star-fill"></i> 编辑精选 · 每日一更
            </span>
            <h2 className="mt-2 text-2xl font-bold text-foreground-950 md:text-3xl">吃瓜福利每日推荐</h2>
            <p className="mt-2 text-sm text-foreground-600">不想一篇篇翻？每天帮你挑好值得追的合集，点开即看。</p>
          </div>
          <span className="inline-flex w-fit items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1.5 text-xs text-accent-700 whitespace-nowrap">
            <i className="ri-sparkling-fill"></i> 今日已推荐 3 组
          </span>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-3">
          {dailyPicks.map((pick, idx) => (
            <div
              key={pick.id}
              className="group overflow-hidden rounded-lg bg-background-50 border border-background-200 transition-colors hover:border-primary-300"
            >
              <div className="relative h-52 overflow-hidden md:h-56">
                <img
                  src={pick.img}
                  alt={pick.title}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-md bg-background-50/90 px-2 py-1 text-[11px] font-medium text-primary-600 whitespace-nowrap">
                  {pick.tag}
                </span>
                <span className="absolute right-3 top-3 rounded-md bg-accent-500/90 px-2 py-1 text-[11px] text-background-50 whitespace-nowrap">
                  {pick.sub}
                </span>
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 text-[11px] text-foreground-500">
                  <span className="flex items-center gap-1 whitespace-nowrap">
                    <i className="ri-calendar-line"></i> {pick.date}
                  </span>
                  <span className="flex items-center gap-1 whitespace-nowrap">
                    <i className="ri-eye-line"></i> {pick.read}
                  </span>
                </div>
                <h3 className="mt-2 text-base font-bold text-foreground-950">
                  <a href="#latest" className="hover:text-primary-600">
                    {idx + 1}. {pick.title}
                  </a>
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{pick.desc}</p>
                <a
                  href="#latest"
                  className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 whitespace-nowrap"
                >
                  去看看 <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}